/* eslint-disable no-unused-vars */
import { Button, Descriptions, Empty, notification, Spin, Tag } from "antd";
// eslint-disable-next-line no-unused-vars
import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { getTransactionDetails } from "../lib/api";
import dayjs from "dayjs";

const TxDetails = () => {
  const [loading, setLoading] = React.useState(true);
  const [descriptionItems, setDescriptionItems] = React.useState([]);
  const [isRefundDoc, setIsRefundDoc] = React.useState(false);
  const [refundStatus, setRefundStatus] = React.useState(false);
  const [refundDetails, setRefundDetails] = React.useState(null);
  const [transactionData, setTransactionData] = React.useState(null);

  const { hash } = useParams();
  const Navigate = useNavigate();

  React.useEffect(() => {
    async function fetchData() {
      try {
        const data = await getTransactionDetails(hash);

        if (data.entry_type === "refund") {
          setIsRefundDoc(true);
          const refundItems = [
            {
              key: "1",
              label: "Refund ID",
              children: data.refundId || hash,
              span: 3,
            },
            {
              key: "2",
              label: "Refund Type",
              children: (
                <Tag color={data.refundType === "full" ? "red" : "orange"}>
                  {data.refundType === "full" ? "Full Refund" : "Partial Refund"}
                </Tag>
              ),
              span: 3,
            },
            {
              key: "3",
              label: "Parts Refunded",
              children: `${data.partsRefunded} / ${data.totalParts}`,
              span: 3,
            },
            {
              key: "4",
              label: "Refund Amount",
              children: `${data.refundAmount} ${data.currency}`,
              span: 3,
            },
            {
              key: "5",
              label: "Stripe Refund ID",
              children: data.stripeRefundId || "N/A",
              span: 3,
            },
            {
              key: "6",
              label: "Price Per Part",
              children: data.pricePerPart ? `${data.pricePerPart} ${data.currency}` : "N/A",
              span: 3,
            },
            {
              key: "10",
              label: "Painting",
              children: data.painting?.title?.en || data.painting?.title?.fr || "N/A",
              span: 3,
            },
            {
              key: "7",
              label: "Related Transaction",
              children: data.transaction_reference_id || "N/A",
              span: 3,
            },
            {
              key: "8",
              label: "Date",
              children: data.processedAt ? dayjs(data.processedAt).format("YYYY-MM-DD HH:mm:ss") : "N/A",
              span: 3,
            },
            {
              key: "9",
              label: "Stripe Status",
              children: data.stripeStatus ? (
                <Tag color={data.stripeStatus === "succeeded" ? "green" : "orange"}>
                  {data.stripeStatus}
                </Tag>
              ) : "N/A",
              span: 3,
            },
          ];
          setDescriptionItems(refundItems);
          setLoading(false);
          return;
        }

                setTransactionData(data);
        setRefundStatus(data.refund || false);
        setRefundDetails(data.refund_details || null);

        const descriptionItemsTemp = [
          {
            key: "1",
            label: "Hash",
            children: data.hash,
            span: 3,
          },
          {
            key: "2",
            label: "Block",
            children: data.blockHash,
            span: 3,
          },
          {
            key: "3",
            label: "Status",
            children: (
              <Tag color={data.status === "success" ? "green" : "default"}>
                {data.status}
              </Tag>
            ),
            span: 3,
          },
          {
            key: "4",
            label: "Timestamp",
            children: dayjs(data.timestamp).format("YYYY-MM-DD HH:mm:ss"),
            span: 3,
          },
          {
            key: "5",
            label: "Owner ID",
            children: data.owner_id_number,
            span: 3,
          },
          {
            key: "5",
            label: "Artwork ID",
            children: data.painting_id,
            span: 3,
          },
          {
            key: "7",
            label: "Transaction ID",
            children: data.transaction_id,
            span: 3,
          },
          {
            key: "8",
            label: "Action Type",
            children: data.type === 1 ? "Buy" : "Sell",
            span: 3,
          },
          {
            key: "6",
            label: "Total Amount",
            children:
              data.total_amount +
              " " +
              (data.total_amount_cur === "USD" ? "$" : "€"),
            span: 3,
          },

          {
            key: "10",
            label: "Input Bytes",
            children: data.inputBytes,
            span: 3,
          },
        ];

        setDescriptionItems(descriptionItemsTemp);
        setLoading(false);
      } catch (error) {
        notification.error({
          message: "Error",
          description: "The transaction hash is does't exist",
        });
        setLoading(false);
      }
    }

    fetchData();
  }, [hash]);

  return loading ? (
    <div className="flex items-center justify-center min-h-screen">
      <Spin size="large" />
    </div>
  ) : (
    <>
      <Button
        type="primary"
        htmlType="button"
        icon={<ArrowLeftOutlined />}
        onClick={() => Navigate(-1)}
      />

            {refundStatus === "total" && (
        <div className="bg-red-50 border border-red-300 rounded-lg p-6 my-4 text-center">
          <h2 className="text-xl font-bold text-red-700 mb-1">Certificate no longer available</h2>
          <p className="text-gray-600 text-sm">This transaction has been fully refunded.</p>
        </div>
      )}

      {refundStatus === "partial" && refundDetails && (
        <div className="bg-orange-50 border border-orange-300 rounded-lg p-4 my-4 flex items-center justify-between">
          <div>
            <Tag color="orange" className="text-sm">Partial Refund</Tag>
            <span className="ml-2 text-sm text-gray-700">
              {refundDetails.partsRefunded} / {refundDetails.totalParts} parts refunded — {refundDetails.refundAmount} {refundDetails.currency}
            </span>
          </div>
        </div>
      )}

      {isRefundDoc && (
        <div className="bg-orange-50 border border-orange-300 rounded-lg p-4 my-4 text-center">
          <Tag color="orange" className="text-base px-3 py-1">Refund Document</Tag>
        </div>
      )}

      {descriptionItems.length > 0 ? (
        <Descriptions
          title={isRefundDoc ? "Refund - " + hash : "Transaction - " + hash}
          items={descriptionItems}
          bordered
        />
      ) : (
        <Empty description="Transaction not found" />
      )}

      {refundStatus === "total" && refundDetails && (
        <Descriptions
          title="Refund Details"
          bordered
          className="mt-4"
          items={[
            {
              key: "r1",
              label: "Refund ID",
              children: transactionData?._id,
              span: 3,
            },
            {
              key: "r2",
              label: "Refund Type",
              children: (
                <Tag color="red">
                  {refundDetails.refundType === "full" ? "Full Refund" : "Partial Refund"}
                </Tag>
              ),
              span: 3,
            },
            {
              key: "r3",
              label: "Parts Refunded",
              children: `${refundDetails.partsRefunded} / ${refundDetails.totalParts}`,
              span: 3,
            },
            {
              key: "r4",
              label: "Refund Amount",
              children: `${refundDetails.refundAmount} ${refundDetails.currency}`,
              span: 3,
            },
            {
              key: "r5",
              label: "Processed At",
              children: refundDetails.processedAt
                ? dayjs(refundDetails.processedAt).format("YYYY-MM-DD HH:mm:ss")
                : "N/A",
              span: 3,
            },
            {
              key: "r6",
              label: "Stripe Refund ID",
              children: refundDetails.stripeRefundId,
              span: 3,
            },
          ]}
        />
      )}
    </>
  );
};

export default TxDetails;
